/**
 * AnalyzeWithAiButton — Story 29-17. A reusable "Analyze with AI" entry point for
 * report + client-detail headers that routes the user to the MCP connect flow.
 *
 * 🔒 INTERLOCK: renders NULL unless `mcpConnectUiEnabled()` is true. With the
 * MCP_CONNECT_UI_ENABLED master switch off (the default), this button does not
 * appear anywhere — the connect surface stays dark until Calin flips it on.
 *
 * Follows the UI design system: rounded-2xl outline button, text-[13px], 0.5px
 * border, Phosphor icon, hover lift.
 */
import { Link } from "@tanstack/react-router";
import { Sparkle } from "@phosphor-icons/react";
import { Button } from "@provenleap/ui";
import { mcpConnectUiEnabled } from "../../lib/mcp/connect-flag";

export function AnalyzeWithAiButton({ className }: { className?: string }) {
  if (!mcpConnectUiEnabled()) return null;

  return (
    <Link to="/settings/ai-access" data-testid="analyze-with-ai">
      <Button
        variant="outline"
        className={`shrink-0 rounded-2xl text-[13px] shadow-xs cursor-pointer hover:bg-background hover:-translate-y-0.5 hover:shadow-sm transition-all ${className ?? ""}`}
        style={{ border: "0.5px solid var(--hairline)" }}
      >
        <Sparkle size={16} className="mr-1.5" />
        Analyze with AI
      </Button>
    </Link>
  );
}
